import React, {Component} from 'react';
import AirDatePicker from "../../../../common/components/AirDatePicker";
import {withRouter} from "react-router-dom";
import {inject, observer} from "mobx-react";

import './FilterBar.css'
import {Button, Select} from "antd";

import AirInLabelSelect from "../../../../common/components/AirInLabelSelect";
import moment from "moment";

const { Option } = Select;

@withRouter
@inject('routeTaskStore', 'translationsStore', 'driversStore')
@observer
export default class FiltersBar extends Component {

  handleCarsChange = (value) => {
    if (value.includes('all')) {
      this.props.routeTaskStore.setSelectedCars([]);
    } else {
      this.props.routeTaskStore.setSelectedCars(value);
    }
  }

  handleFilterReset = () => {
    const { routeTaskStore } = this.props;
    routeTaskStore.resetFilters();
    routeTaskStore.load();
  }

  render() {
    const { routeTaskStore, translationsStore, driversStore } = this.props;

    return <div className="FiltersBar">
      <div className="DateRangeSelector">
        <AirDatePicker
          selected={routeTaskStore.filtersCollection.fromDate? new Date(routeTaskStore.filtersCollection.fromDate) : undefined}
          onChange={value => routeTaskStore.setFilter('fromDate', moment(value).format('YYYY-MM-DD'))}
          prefix={translationsStore.translate('routePlanning.filter.date.from')}
          maxDate={routeTaskStore.filtersCollection.toDate? new Date(routeTaskStore.filtersCollection.toDate) : undefined}
        />
        <AirDatePicker
          selected={routeTaskStore.filtersCollection.toDate? new Date(routeTaskStore.filtersCollection.toDate) : undefined}
          onChange={value => routeTaskStore.setFilter('toDate', moment(value).format('YYYY-MM-DD'))}
          prefix={translationsStore.translate('routePlanning.filter.date.to')}
          minDate={routeTaskStore.filtersCollection.fromDate? new Date(routeTaskStore.filtersCollection.fromDate) : undefined}
        />
      </div>
      <Button onClick={this.handleFilterReset}>{translationsStore.translate('routePlanning.filter.reset')}</Button>
      <AirInLabelSelect
        label={translationsStore.translate('routePlanning.filter.status.label')}
        value={routeTaskStore.filtersCollection.status}
        onChange={value => routeTaskStore.setFilter('status', value)}
      >
        <Option value="all">{translationsStore.translate('routePlanning.filter.status.all')}</Option>
        <Option value="not-started">{translationsStore.translate('routePlanning.filter.status.not-started')}</Option>
        <Option value="started">{translationsStore.translate('routePlanning.filter.status.started')}</Option>
        <Option value="closed">{translationsStore.translate('routePlanning.filter.status.closed')}</Option>
      </AirInLabelSelect>
      <AirInLabelSelect
        label={translationsStore.translate('routePlanning.filter.driver.label')}
        value={routeTaskStore.filtersCollection.driverId}
        onChange={value => routeTaskStore.setFilter('driverId', value)}
      >
        <Option value="all">{translationsStore.translate('routePlanning.filter.driver.all')}</Option>
        {driversStore.drivers.map( driver => <Option key={driver.id} value={driver.id}>{`${driver.name} ${driver.surname}`}</Option>)}
      </AirInLabelSelect>
      <AirInLabelSelect
        label={translationsStore.translate('routePlanning.filter.sorting.label')}
        value={routeTaskStore.filtersCollection.sort}
        onChange={value => routeTaskStore.setFilter('sort', value)}
      >
        <Option value="DESC">{translationsStore.translate('routePlanning.filter.sorting.newest')}</Option>
        <Option value="ASC">{translationsStore.translate('routePlanning.filter.sorting.oldest')}</Option>
      </AirInLabelSelect>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/App/RouteTaskDashboard/FiltersBar/FiltersBar.js